import {
	Text,
	HStack,
	Button,
	VStack,
} from '@montel/montelpro-shared-components-v2';
import { StandardModal } from 'components/common/Modal/StandardModal';
import { FunctionComponent } from 'react';
import { NewSystemEntity } from './NewSystemEntity';

interface NewEntityModalProps {
	showModal: boolean;
	onCloseModal: () => void;
	newEntity: NewSystemEntity;
}

export const NewEntityModal: FunctionComponent<NewEntityModalProps> = ({
	showModal,
	onCloseModal,
	newEntity,
}) => (
	<StandardModal
		isOpen={showModal}
		onClose={onCloseModal}
		header={`New Entity: ${newEntity.name}`}
		footer={
			<HStack gap="md">
				<Button
					text="OK"
					size="sm"
					variant="secondary"
					onClick={onCloseModal}
				/>
			</HStack>
		}
	>
		<VStack gap="lg">
			<Text>
				<b>Client ID: </b>
				{newEntity.clientId}
			</Text>
			<Text>
				<b>Client Secret: </b>
				{newEntity.clientSecret}
			</Text>
			<Text fontStyle="italic" size="sm">
				Copy and save these values, they will not be visible once this
				modal is closed.
			</Text>
		</VStack>
	</StandardModal>
);
